<!--职位详情-->
<template>
  <div class="position-details-container">
    <header-index/>
    <div class="position-details-content">
      <div class="position-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+pName }">{{ pName }}
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/recruit/index?pName='+pName }">企业招聘</el-breadcrumb-item>
          <el-breadcrumb-item>职位详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="position-details-details">
        <div class="table-header">
          <div class="table-group-th">
            <span class="bold-span">{{ positionDetail.name }}</span>
            <span class="red-span" v-if="positionDetail.negotiable!=1">{{ positionDetail.salary }}</span>
            <span class="red-span" v-else>薪资面议</span>
          </div>
          <div class="table-group-td">
            <span class="normal-span">{{ positionDetail.workArea }}</span>
            <el-divider direction="vertical"/>
            <span class="normal-span">{{ positionDetail.workingYears }}</span>
            <el-divider direction="vertical"/>
            <span class="normal-span">{{ positionDetail.education }}</span>
          </div>
          <div class="table-label">
            <i class="welfare" v-for="welfareArray of positionDetail.welfareArray">{{welfareArray}}</i>
          </div>
        </div>
        <div class="position-content">
          <p class="position-title">职位描述</p>
          <div class="position-info" v-html="positionDetail.content"></div>
          <p class="position-title">工作地点</p>
          <div class="position-info"><i class="el-icon-location" style="padding-right: 15px"/>{{positionDetail.addressFormat}}</div>
          <p class="position-title">公司信息</p>
          <div class="position-info">{{positionDetail.companyName}}</div>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {homepageRecruitmentDetails} from '@/api/recruitApi'

export default {
  name: "positionDetails",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      positionDetail: {},
      id: 0,
      cid: 0,
      pName: '',
    }
  },
  methods: {
    /*获取职位详情*/
    getPositionDetail() {
      homepageRecruitmentDetails({
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        id: this.id
      }).then(res => {
        if (res.code == 200) {
          let reg = new RegExp('\\n', 'g')//g代表全部
          if (res.content.content){
            res.content.content=res.content.content.replace(reg, '<br/>');
          }
          this.positionDetail = res.content;
        }
      })
    },
  },
  mounted() {
    this.getPositionDetail();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.pName = this.$route.query.pName;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.position-details-container >>> .position-details-content .position-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.position-details-container >>> .position-details-content .position-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.position-details-container >>> .position-details-content .position-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.position-details-container >>> .position-details-content .position-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.position-details-container >>> .position-details-content .position-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.position-details-container {
  background: #E7E9F5;

  .position-details-content {
    padding: 20px 18%;
    min-width: 76rem;
    .position-details-details {
      background: #ffffff;
      padding: 30px 20px;
      .table-header {
        border-bottom: 1px solid #E7E9F5;

        .table-group-th {
          display: flex;
          justify-content: space-between;

          .bold-span {
            color: #333333;
            font-size: 24px;
            font-weight: 100;
            font-family: 'SourceHanSansCN';
          }

          .red-span {
            color: #FE273B;
            font-size: 24px;
            font-family: 'SourceHanSansCN';
          }
        }

        .table-group-td {
          line-height: 45px;

          .el-divider {
            background-color: #999999;
          }

          .normal-span {
            color: #333333;
            font-family: 'SourceHanSansCN';
            font-size: 14px;
          }
        }
        .table-label{
          display: flex;
          padding-bottom: 30px;
          .welfare{
            font-style: normal;
            font-size: 14px;
            background: #F5F5F5;
            border: 1px solid #DDDDDD;
            border-radius: 4px;
            padding: 5px 10px;
            margin-right: 10px;
          }
        }
      }
      .position-content{
        .position-title{
          font-size: 18px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          color: #333333;
        }
        .position-info{
          line-height: 32px;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          color: #666666;
        }
      }
    }

    .position-breadcrumb {
      padding-bottom: 20px;
    }
  }
}
</style>